import type { ConfigRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-node';
import { type ApiClientResponse, nodeApiClient, nodeApiRoutes } from 'common/services';

type NodeUsersDataObject = paths['/users']['get']['responses']['default']['content']['application/json'];
type NodeUsersQueryRequestParams = paths['/users']['get']['requestBody']['content']['application/json'];

export const getNodeUsers = async ({ config }: ConfigRequest<NodeUsersQueryRequestParams>) =>
  nodeApiClient.get<NodeUsersDataObject, ApiClientResponse<NodeUsersDataObject>>(nodeApiRoutes.users.find, config);
